export const getPersianNumber = number => {
  if (!number && number !== 0) return ''
  const numberString = number.toString()
  return Array(numberString.length).fill(0).reduce((total, n, index) => {
    let digit = numberString.charAt(index)
    if (!isNaN(digit)) digit = FaDigit[digit]
    return total + '' + digit
  }, '')
}

const FaDigit = {
  0: '۰',
  1: '۱',
  2: '۲',
  3: '۳',
  4: '۴',
  5: '۵',
  6: '۶',
  7: '۷',
  8: '۸',
  9: '۹',
}